import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './correction-factor.reducer';

export const CorrectionFactorDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const correctionFactorEntity = useAppSelector(state => state.correctionFactor.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="correctionFactorDetailsHeading">
          <Translate contentKey="crawlerBackendApp.correctionFactor.detail.title">CorrectionFactor</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{correctionFactorEntity.id}</dd>
          <dt>
            <span id="correctionFactor">
              <Translate contentKey="crawlerBackendApp.correctionFactor.correctionFactor">Correction Factor</Translate>
            </span>
          </dt>
          <dd>{correctionFactorEntity.correctionFactor}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.correctionFactor.effectiveDate">Effective Date</Translate>
            </span>
          </dt>
          <dd>
            {correctionFactorEntity.effectiveDate ? (
              <TextFormat value={correctionFactorEntity.effectiveDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="expirationDate">
              <Translate contentKey="crawlerBackendApp.correctionFactor.expirationDate">Expiration Date</Translate>
            </span>
          </dt>
          <dd>
            {correctionFactorEntity.expirationDate ? (
              <TextFormat value={correctionFactorEntity.expirationDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/correction-factor" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/correction-factor/${correctionFactorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CorrectionFactorDetail;
